import { render, staticRenderFns } from "./BriefcaseOutline.vue?vue&type=template&id=4e67ca49&"
import script from "./BriefcaseOutline.vue?vue&type=script&lang=js&"
export * from "./BriefcaseOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports